import { SubscriptionPlanName } from '@sparemin/api-sdk';
import { SubscriptionPeriod } from 'blocks/Pricing/types';
import bem from 'utils/bem';
import { BillingCyclePlanOptions } from '../BillingCycleModal/BillingCycleOptions';

const PLAN_OPTIONS: BillingCyclePlanOptions[] = [
  {
    monthly: SubscriptionPlanName.PRO_MONTHLY,
    yearly: SubscriptionPlanName.PRO_YEARLY,
  },
  {
    monthly: SubscriptionPlanName.PRO_20200922_MONTHLY,
    yearly: SubscriptionPlanName.PRO_20200922_YEARLY,
  },
  {
    monthly: SubscriptionPlanName.PRO_20211112_MONTHLY,
    yearly: SubscriptionPlanName.PRO_20211112_YEARLY,
  },
  {
    monthly: SubscriptionPlanName.PRO_20250516_MONTHLY,
    yearly: SubscriptionPlanName.PRO_20250516_YEARLY,
  },
  {
    monthly: SubscriptionPlanName.PRO_20250818_MONTHLY,
    yearly: SubscriptionPlanName.PRO_20250818_YEARLY,
  },
  {
    monthly: SubscriptionPlanName.PRO_GROW_20251120_MONTHLY,
    yearly: SubscriptionPlanName.PRO_GROW_20251120_YEARLY,
  },
  {
    monthly: SubscriptionPlanName.BASIC_20200922_MONTHLY,
    yearly: SubscriptionPlanName.BASIC_20200922_YEARLY,
  },
  {
    monthly: SubscriptionPlanName.BASIC_20211112_MONTHLY,
    yearly: SubscriptionPlanName.BASIC_20211112_YEARLY,
  },
  {
    monthly: SubscriptionPlanName.BASIC_20250516_MONTHLY,
    yearly: SubscriptionPlanName.BASIC_20250516_YEARLY,
  },
  {
    monthly: SubscriptionPlanName.BASIC_20250818_MONTHLY,
    yearly: SubscriptionPlanName.BASIC_20250818_YEARLY,
  },
  {
    monthly: SubscriptionPlanName.UNLIMITED_20211112_MONTHLY,
    yearly: SubscriptionPlanName.UNLIMITED_20211112_YEARLY,
  },
];

export function getPlanOptionsFromCurrentPlan(
  currentPlan: SubscriptionPlanName,
): BillingCyclePlanOptions {
  return PLAN_OPTIONS.find(opt => Object.values(opt).includes(currentPlan));
}

export const block = bem('update-billing-cycle');

export const isDowngradingCycle = (
  initialCycle: SubscriptionPeriod,
  selectedCycle: SubscriptionPeriod,
): boolean => initialCycle === 'yearly' && selectedCycle === 'monthly';
